import MinhaConta from './components/MinhaConta';
import Dashboard from './components/Dashboard';
import AuthPanel from './components/AuthPanel';
import PWAInstallBanner from './components/PWAInstallBanner';
import OfflineIndicator from './components/OfflineIndicator';
import BottomNav from './components/BottomNav';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import logoQRCodexpress from './assets/QRcodeXpress.png';
import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './components/LandingPage';
import ControlPanel from './components/ControlPanel';
import AdminUserPage from './components/AdminUserPage';
import Plans from './components/Plans';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import SeoIntentPage from './components/SeoIntentPage';
import LegalPage from './components/LegalPage';
import axios from 'axios';
import QRGenerator from './components/QRGenerator';
import { generateLocalQR } from './components/qrLocal';
import { usePWAInstall } from './hooks/usePWAInstall';
import { initializePWA, DeviceDetection, PWAInstall } from './utils/pwaUtils';
import { API_BASE } from './utils/apiBase';
import './App.css';
import './styles/mobile.css';

function RouterApp() {
  const location = useLocation();
  // Estados necessários para buildContent
  const [tab, setTab] = useState('url');
  // Corrigir setTab('url') no render
  useEffect(() => {
    if (tab === '') setTab('url');
  }, [tab]);
  // Estados necessários para buildContent
  const [emailTo, setEmailTo] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [smsNumber, setSmsNumber] = useState('');
  const [smsBody, setSmsBody] = useState('');
  const [wifiSsid, setWifiSsid] = useState('');
  const [wifiPass, setWifiPass] = useState('');
  const [wifiEnc, setWifiEnc] = useState('WPA');
  const [wifiHidden, setWifiHidden] = useState(false);
  const [vcFirst, setVcFirst] = useState('');
  const [vcLast, setVcLast] = useState('');
  const [vcOrg, setVcOrg] = useState('');
  const [vcTitle, setVcTitle] = useState('');
  const [vcPhone, setVcPhone] = useState('');
  const [vcEmail, setVcEmail] = useState('');
  const [vcUrl, setVcUrl] = useState('');
  // Estado para lista de usuários (admin)
  const [users, setUsers] = useState([]);
  // Estado para analytics do admin
  const [analytics, setAnalytics] = useState({});
  // Estados para registro
  const [registerName, setRegisterName] = useState('');
  const [registerEmail, setRegisterEmail] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const [registerLGPD, setRegisterLGPD] = useState(false);
  const [captchaA, setCaptchaA] = useState(Math.floor(Math.random()*10)+1);
  const [captchaB, setCaptchaB] = useState(Math.floor(Math.random()*10)+1);
  const [captchaInput, setCaptchaInput] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const [showLGPD, setShowLGPD] = useState(false);
  const honeypotReportedRef = useRef(false);

  useEffect(() => {
    const siteUrl = (process.env.REACT_APP_SITE_URL || 'https://qrcodexpress.com.br').replace(/\/$/, '');
    const seoByPath = {
      '/': {
        title: 'QRCodeXpress - Gerador de QR Code Online',
        description: 'Crie QR Codes profissionais com personalização completa, exportação em PNG, SVG e PDF e gestão avançada para negócios.'
      },
      '/home': {
        title: 'QRCodeXpress - Gerador de QR Code Online',
        description: 'Plataforma completa para criar QR Codes customizados com rapidez, segurança e qualidade profissional.'
      },
      '/qrcode-generator': {
        title: 'Gerador de QR Code Personalizado | QRCodeXpress',
        description: 'Gere QR Codes personalizados para URL, Wi-Fi, WhatsApp, vCard e mais. Exporte em PNG, SVG e PDF.'
      },
      '/planos': {
        title: 'Planos QRCodeXpress | Free, Pro e Business',
        description: 'Compare os planos QRCodeXpress e escolha a melhor opção para gerar, gerenciar e escalar seus QR Codes.'
      },
      '/faq': {
        title: 'FAQ QRCodeXpress | Dúvidas Frequentes',
        description: 'Veja respostas sobre geração de QR Code, personalização, exportação, planos e recursos da plataforma.'
      },
      '/contato': {
        title: 'Contato QRCodeXpress',
        description: 'Fale com a equipe QRCodeXpress para suporte, dúvidas comerciais e parcerias.'
      },
      '/privacy': {
        title: 'Política de Privacidade | QRCodeXpress',
        description: 'Saiba como a QRCodeXpress coleta, utiliza e protege dados pessoais na plataforma.'
      },
      '/terms': {
        title: 'Termos de Uso | QRCodeXpress',
        description: 'Conheça as condições de uso da plataforma QRCodeXpress e responsabilidades das partes.'
      },
      '/lgpd': {
        title: 'LGPD | QRCodeXpress',
        description: 'Veja como a QRCodeXpress trata dados pessoais em conformidade com a LGPD.'
      },
      '/cookies': {
        title: 'Política de Cookies | QRCodeXpress',
        description: 'Entenda como utilizamos cookies para melhorar segurança, performance e experiência do usuário.'
      },
      '/qr-code-whatsapp': {
        title: 'QR Code para WhatsApp | QRCodeXpress',
        description: 'Crie QR Code para WhatsApp e permita contato direto com sua empresa em um único escaneamento.'
      },
      '/qr-code-wifi': {
        title: 'QR Code para Wi-Fi | QRCodeXpress',
        description: 'Gere QR Code de Wi-Fi para conectar clientes e visitantes automaticamente à sua rede.'
      },
      '/qr-code-vcard': {
        title: 'QR Code vCard | Cartão de Visita Digital',
        description: 'Crie QR Code vCard para compartilhar contatos profissionais com rapidez e praticidade.'
      },
      '/whatsapp-business-com-qr-code': {
        title: 'WhatsApp Business com QR Code | QRCodeXpress',
        description: 'Aprenda a usar QR Code no WhatsApp Business para acelerar atendimento e gerar mais conversões.'
      },
      '/wifi-para-clientes-com-qr-code': {
        title: 'Wi-Fi para Clientes com QR Code | QRCodeXpress',
        description: 'Melhore a experiência de visitantes com acesso Wi-Fi rápido e seguro via QR Code.'
      },
      '/vcard-digital-para-equipes': {
        title: 'vCard Digital para Equipes | QRCodeXpress',
        description: 'Padronize compartilhamento de contatos com QR Code vCard para equipes comerciais e atendimento.'
      },
      '/connect': {
        title: 'Entrar na Conta | QRCodeXpress',
        description: 'Acesse sua conta QRCodeXpress para gerenciar QR Codes, histórico e plano.'
      },
      '/minha-conta': {
        title: 'Minha Conta | QRCodeXpress',
        description: 'Gerencie seu perfil, histórico de QR Codes e recursos da sua assinatura.'
      }
    };

    const pageSeo = seoByPath[location.pathname] || seoByPath['/'];
    const canonicalUrl = `${siteUrl}${location.pathname === '/' ? '' : location.pathname}`;

    document.title = pageSeo.title;

    const updateMeta = (selector, value) => {
      const tag = document.querySelector(selector);
      if (tag && value) tag.setAttribute('content', value);
    };

    updateMeta('meta[name="description"]', pageSeo.description);
    updateMeta('meta[property="og:title"]', pageSeo.title);
    updateMeta('meta[property="og:description"]', pageSeo.description);
    updateMeta('meta[property="og:url"]', canonicalUrl);
    updateMeta('meta[property="twitter:title"]', pageSeo.title);
    updateMeta('meta[property="twitter:description"]', pageSeo.description);
    updateMeta('meta[property="twitter:url"]', canonicalUrl);

    const canonicalTag = document.querySelector('#canonical-link');
    if (canonicalTag) canonicalTag.setAttribute('href', canonicalUrl);

    const routeLabels = {
      '/': 'Início',
      '/home': 'Início',
      '/qrcode-generator': 'Gerador de QR Code',
      '/planos': 'Planos',
      '/faq': 'FAQ',
      '/contato': 'Contato',
      '/privacy': 'Política de Privacidade',
      '/terms': 'Termos de Uso',
      '/lgpd': 'LGPD',
      '/cookies': 'Cookies',
      '/qr-code-whatsapp': 'QR Code para WhatsApp',
      '/qr-code-wifi': 'QR Code para Wi-Fi',
      '/qr-code-vcard': 'QR Code vCard',
      '/whatsapp-business-com-qr-code': 'WhatsApp Business com QR Code',
      '/wifi-para-clientes-com-qr-code': 'Wi-Fi para Clientes com QR Code',
      '/vcard-digital-para-equipes': 'vCard Digital para Equipes',
      '/connect': 'Entrar',
      '/minha-conta': 'Minha Conta'
    };

    const itemList = [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Início',
        item: `${siteUrl}/`
      }
    ];

    if (location.pathname !== '/' && location.pathname !== '/home') {
      itemList.push({
        '@type': 'ListItem',
        position: 2,
        name: routeLabels[location.pathname] || 'Página',
        item: canonicalUrl
      });
    }

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: itemList
    };

    let breadcrumbTag = document.querySelector('#breadcrumb-jsonld');
    if (!breadcrumbTag) {
      breadcrumbTag = document.createElement('script');
      breadcrumbTag.setAttribute('id', 'breadcrumb-jsonld');
      breadcrumbTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(breadcrumbTag);
    }
    breadcrumbTag.textContent = JSON.stringify(breadcrumbSchema);
  }, [location.pathname]);

  useEffect(() => {
    if (!location.hash) return;

    const targetId = location.hash.replace('#', '');

    const scrollToTarget = () => {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    scrollToTarget();
    const timeoutId = setTimeout(scrollToTarget, 120);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.hash]);

  // Estados para autenticação e controle de view
  // Persistência de autenticação
  const [token, setTokenState] = useState(() => localStorage.getItem('token'));
  const [userEmail, setUserEmailState] = useState(() => localStorage.getItem('userEmail') || '');
  const [userRole, setUserRoleState] = useState(() => {
  const t = localStorage.getItem('token');
    if (!t) return 'user';
    try {
      const decoded = JSON.parse(atob(t.split('.')[1]));
      return decoded.role || 'user';
    } catch {
      return 'user';
    }
  });

  // Setters que sincronizam com localStorage
  const setToken = (val) => {
    setTokenState(val);
    if (val) {
      localStorage.setItem('token', val);
    } else {
      localStorage.removeItem('token');
    }
  };
  const setUserEmail = (val) => {
    setUserEmailState(val);
    if (val) {
      localStorage.setItem('userEmail', val);
    } else {
      localStorage.removeItem('userEmail');
    }
  };
  const setUserRole = (val) => {
    setUserRoleState(val);
    if (val) {
      localStorage.setItem('userRole', val);
    } else {
      localStorage.removeItem('userRole');
    }
  };

  // Sempre sincronizar userRole ao mudar o token
  useEffect(() => {
    if (!token) {
      setUserRole('user');
      return;
    }
    try {
      const decoded = JSON.parse(atob(token.split('.')[1]));
      setUserRole(decoded.role || 'user');
      setUserEmail(decoded.email || '');
    } catch {
      setUserRole('user');
      setUserEmail('');
    }
  }, [token]);
  
  const navigate = useNavigate();
  const [view, setView] = useState('generator'); // 'generator' | 'user' | 'admin'
  const [errorMessage, setErrorMessage] = useState('');

  // Capturar token do Google OAuth da URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');
    const emailFromUrl = urlParams.get('email');
    const roleFromUrl = urlParams.get('role');
    const oauthError = urlParams.get('oauthError');
    
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
      if (emailFromUrl) setUserEmail(decodeURIComponent(emailFromUrl));
      if (roleFromUrl) setUserRole(roleFromUrl);
      
      // Limpar a URL
      window.history.replaceState({}, document.title, window.location.pathname);
      
      // Redirecionar para a home
      navigate('/');
      return;
    }

    if (oauthError) {
      const oauthMessages = {
        google_auth_failed: 'Falha ao autenticar com o Google. Verifique a configuração OAuth e tente novamente.',
        google_login_denied: 'Login com Google foi cancelado ou negado.',
        token_generation_failed: 'Não foi possível concluir o login com Google no momento.'
      };

      setErrorMessage(oauthMessages[oauthError] || 'Erro ao entrar com Google. Tente novamente.');
      window.history.replaceState({}, document.title, window.location.pathname);
      navigate('/connect');
    }
  }, [navigate, setErrorMessage, setToken, setUserEmail, setUserRole]);

  // Estados para perfil do usuário (área reservada)
  const [userName, setUserName] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [userCompany, setUserCompany] = useState('');
  const [acceptsPromos, setAcceptsPromos] = useState(false);
  const [userCreatedAt, setUserCreatedAt] = useState(null);
  const [subscription, setSubscription] = useState(() => localStorage.getItem('subscription') || 'none');

  // Setter que sincroniza com localStorage
  const updateSubscription = (val) => {
    setSubscription(val);
    if (val) {
      localStorage.setItem('subscription', val);
    } else {
      localStorage.removeItem('subscription');
    }
  };

  const reportHoneyPotAttempt = useCallback(async (reason, metadata = {}) => {
    if (honeypotReportedRef.current) return;
    if (userRole === 'admin') return;

    honeypotReportedRef.current = true;

    try {
      await fetch(`${API_BASE}/api/security/honeypot`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify({
          reason,
          path: window.location.pathname,
          metadata
        })
      });
    } catch {
      // noop
    }
  }, [token, userRole]);

  useEffect(() => {
    if (userRole === 'admin') return;

    const handleInspectShortcuts = (event) => {
      const key = (event.key || '').toLowerCase();
      const isInspectShortcut =
        event.key === 'F12' ||
        ((event.ctrlKey || event.metaKey) && event.shiftKey && ['i', 'j', 'c'].includes(key)) ||
        ((event.ctrlKey || event.metaKey) && key === 'u');

      if (!isInspectShortcut) return;

      event.preventDefault();
      reportHoneyPotAttempt('keyboard_shortcut', {
        key: event.key,
        ctrl: !!event.ctrlKey,
        shift: !!event.shiftKey,
        meta: !!event.metaKey
      });
    };

    const handleContextMenu = (event) => {
      if (!event.ctrlKey && !event.shiftKey && !event.metaKey) return;
      reportHoneyPotAttempt('contextmenu_modifier', {
        x: event.clientX,
        y: event.clientY
      });
    };

    let wasOpen = false;
    const interval = setInterval(() => {
      const threshold = 160;
      const devtoolsOpen =
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold;

      if (devtoolsOpen && !wasOpen) {
        reportHoneyPotAttempt('devtools_open');
      }

      wasOpen = devtoolsOpen;
    }, 2000);

    window.addEventListener('keydown', handleInspectShortcuts);
    window.addEventListener('contextmenu', handleContextMenu);

    return () => {
      clearInterval(interval);
      window.removeEventListener('keydown', handleInspectShortcuts);
      window.removeEventListener('contextmenu', handleContextMenu);
    };
  }, [userRole, reportHoneyPotAttempt]);

  // Carregar dados do usuário ao entrar na área do usuário
  useEffect(() => {
    if (token && view === 'user') {
      axios.get(`${API_BASE}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => {
        setUserName(res.data.name || '');
        setUserPhone(res.data.phone || '');
        setUserCompany(res.data.company || '');
        setAcceptsPromos(!!res.data.acceptsPromos);
        setUserCreatedAt(res.data.createdAt || null);
        updateSubscription(res.data.subscription || 'none');
        console.log('[UserArea] Dados do perfil carregados:', res.data);
      }).catch(()=>{});
    }
  }, [token, view]);
  // Função para registro de usuário
  const [registerRole, setRegisterRole] = useState('user');
  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    setCaptchaError('');
    setSuccessMessage('');
    if (!registerName || !registerEmail || !registerPassword || !registerLGPD || Number(captchaInput)!==(captchaA+captchaB)) {
      setCaptchaError('Preencha todos os campos corretamente.');
      return;
    }
    try {
      await axios.post(`${API_BASE}/api/auth/register`, {
        name: registerName,
        email: registerEmail,
        password: registerPassword,
        role: registerRole,
        lgpd: registerLGPD
      });
      setSuccessMessage('Registro realizado com sucesso! Faça login.');
      setRegisterName('');
      setRegisterEmail('');
      setRegisterPassword('');
      setRegisterLGPD(false);
      setCaptchaInput('');
      setRegisterRole('user');
      setCaptchaA(Math.floor(Math.random()*10)+1);
      setCaptchaB(Math.floor(Math.random()*10)+1);
    } catch (err) {
      setCaptchaError('Erro ao registrar. Tente outro email.');
    }
  };
  
  const [showUserMenu, setShowUserMenu] = useState(false);

  function UserMenu() {
    // Fecha o menu ao clicar fora
    const menuRef = useRef();
        useEffect(() => {
          if (!showUserMenu) return;
          function handleClick(e) {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
              setShowUserMenu(false);
            }
          }
          document.addEventListener('mousedown', handleClick);
          return () => document.removeEventListener('mousedown', handleClick);
        }, [showUserMenu]);
    return (
      <div style={{position:'relative'}} ref={menuRef}>
        <button className="auth-btn usermenu-btn" onClick={() => setShowUserMenu(v => !v)}>
          <span style={{display:'inline-flex',alignItems:'center',gap:6}}>
            {/* Ícone formal de usuário azul */}
            <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" fill="#0ea5e9"/><path d="M4 20c0-3.314 3.134-6 7-6s7 2.686 7 6" fill="#b6e6f7"/></svg>
            Painel do Usuário
            {/* Seta branca, delicada */}
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M5 7l5 5 5-5" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </span>
        </button>
        {showUserMenu && (
          <div className="usermenu-dropdown">
            {userRole === 'admin' && (
              <button className="menu-item" style={{color:'#333'}} onClick={() => { setShowUserMenu(false); setView('admin'); navigate('/admin'); }}>
                <span className="menu-icon">
                  {/* Ícone dashboard formal azul */}
                  <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="2" fill="#0ea5e9"/><rect x="14" y="3" width="7" height="7" rx="2" fill="#b6e6f7"/><rect x="14" y="14" width="7" height="7" rx="2" fill="#0ea5e9"/><rect x="3" y="14" width="7" height="7" rx="2" fill="#b6e6f7"/></svg>
                </span>
                Dashboard
              </button>
            )}
            <button className="menu-item" style={{color:'#333'}} onClick={() => { setShowUserMenu(false); setView('user'); navigate('/user'); }}>
              <span className="menu-icon">
                {/* Ícone formal usuário azul */}
                <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" fill="#0ea5e9"/><path d="M4 20c0-3.314 3.134-6 7-6s7 2.686 7 6" fill="#b6e6f7"/></svg>
              </span>
              Área do Usuário
            </button>
            <div className="menu-divider" />
            <button className="menu-item" style={{color:'#333'}} onClick={() => { setShowUserMenu(false); handleLogout(); }}>
              <span className="menu-icon">
                {/* Ícone formal sair azul */}
                <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M16 17l5-5-5-5" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M21 12H9" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><rect x="3" y="5" width="6" height="14" rx="2" fill="#b6e6f7"/></svg>
              </span>
              Sair
            </button>
          </div>
        )}
      </div>
    );
  }
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const authRef = useRef(null);
  const [successMessage, setSuccessMessage] = useState('');
  // History states
  const [qrHistory, setQrHistory] = useState([]);
  
  // PWA Install
  const { isInstallable, isInstalled, installPWA } = usePWAInstall();
  

  // content
  const [qrText, setQrText] = useState('https://website.com');
  const [geoLat, setGeoLat] = useState('');
  const [geoLng, setGeoLng] = useState('');
  const [fbUrl, setFbUrl] = useState('');
  const [twText, setTwText] = useState('');
  const [twUrl, setTwUrl] = useState('');
  const [ytUrl, setYtUrl] = useState('');
  const [evTitle, setEvTitle] = useState('');
  const [evLocation, setEvLocation] = useState('');
  const [evStart, setEvStart] = useState('');
  const [evEnd, setEvEnd] = useState('');
  const [evDesc, setEvDesc] = useState('');
  const [btcAddress, setBtcAddress] = useState('');
  const [btcAmount, setBtcAmount] = useState('');

  // colors
  const [bodyColor, setBodyColor] = useState('#13294B');
  const [bgColor, setBgColor] = useState('#FFFFFF');
  const [gradient, setGradient] = useState(false);
  const [gradientColor1, setGradientColor1] = useState('#1B4965');
  const [gradientColor2, setGradientColor2] = useState('#5FA8D3');
  const [gradientType, setGradientType] = useState('linear');

  // design
  const [body, setBody] = useState('square');
  const [eye, setEye] = useState('frame0');
  const [eyeBall, setEyeBall] = useState('ball0');

  // size and file
  const [size, setSize] = useState(600);
  const [fileType, setFileType] = useState('png');

  // logo
  const [logoFile, setLogoFile] = useState(null);
  const [logoDataUrl, setLogoDataUrl] = useState('');
  const [logoModeClean, setLogoModeClean] = useState(false);

  // output
  const [imageDataUrl, setImageDataUrl] = useState('');
  const [loading, setLoading] = useState(false);


  // Admin functions
  const fetchUsers = useCallback(async () => {
    console.log('Token usado no fetchUsers:', token);
    try {
      const res = await axios.get(`${API_BASE}/api/admin/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log('Usuários recebidos do backend:', res.data);
      setUsers(res.data);
    } catch (error) {
      console.error('Failed to fetch users', error);
    }
  }, [token]);

  // Logar sempre que users mudar
  useEffect(() => {
    console.log('Estado users no App.js:', users);
  }, [users]);

  const fetchAnalytics = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/admin/analytics`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAnalytics(res.data);
    } catch (error) {
      console.error('Failed to fetch analytics');
    }
  }, [token]);

  // History functions
  const fetchQrHistory = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/qr/history`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setQrHistory(res.data);
    } catch (error) {
      console.error('Failed to fetch QR history');
    }
  }, [token]);

    // Detect backend capabilities (RapidAPI on/off)
  useEffect(() => {
    if (token && userRole === 'admin') {
      console.log('Token usado no useEffect admin:', token);
      fetchUsers();
      fetchAnalytics();
      // Sincroniza subscription localStorage
      axios.get(`${API_BASE}/api/admin/users`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(userRes => {
        const found = userRes.data.find(u => u.email === userEmail);
        if (found && found.subscription) {
          localStorage.setItem('subscription', found.subscription);
        } else {
          localStorage.setItem('subscription', 'none');
        }
        console.log('Sincronização de subscription, users:', userRes.data);
      }).catch((err)=>{console.error('Erro ao sincronizar subscription', err);});
    }
  }, [token, userRole, fetchUsers, fetchAnalytics, userEmail]);



  useEffect(() => {
    if (token && view === 'user') {
      fetchQrHistory();
    }
  }, [token, view, fetchQrHistory]);

  const handleLogin = async () => {
    setErrorMessage('');
    setSuccessMessage('');
    try {
      const res = await axios.post(`${API_BASE}/api/auth/login`, { email, password });
  setToken(res.data.token);
  localStorage.setItem('token', res.data.token);
  // Decode token to get role
  const decoded = JSON.parse(atob(res.data.token.split('.')[1]));
  setUserEmail(decoded.email || email);
  // userRole será atualizado automaticamente pelo useEffect do token
  localStorage.setItem('userEmail', decoded.email || email);
      // Buscar dados completos do usuário para pegar subscription
      const userRes = await axios.get(`${API_BASE}/api/auth/me`, {
        headers: { Authorization: `Bearer ${res.data.token}` }
      });
      if (userRes.data) {
        updateSubscription(userRes.data.subscription || 'none');
        setUserName(userRes.data.name || '');
        setUserPhone(userRes.data.phone || '');
        setUserCompany(userRes.data.company || '');
        setAcceptsPromos(!!userRes.data.acceptsPromos);
        setUserCreatedAt(userRes.data.createdAt || null);
        console.log('[Login] Dados do usuário carregados:', userRes.data);
      } else {
        updateSubscription('none');
      }
      setSuccessMessage('Login realizado com sucesso!');
      // Redirecionamento automático após login - todos vão para /minha-conta
      navigate('/minha-conta');
    } catch (error) {
      setErrorMessage(error.response?.data?.error || 'Erro no login');
    }
  };

  const handleRegister = async () => {
    setErrorMessage('');
    setSuccessMessage('');
    try {
      await axios.post(`${API_BASE}/api/auth/register`, { email, password });
      setSuccessMessage('Registro realizado com sucesso! Faça login.');
    } catch (error) {
      setErrorMessage(error.response?.data?.error || 'Erro no registro');
    }
  };

  const handleLogout = () => {
    setToken(null);
    setUserEmail('');
    setUserRole('user');
    setUserName('');
    setUserPhone('');
    setUserCompany('');
    setAcceptsPromos(false);
    setUserCreatedAt(null);
    updateSubscription('none');
    localStorage.removeItem('token');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userRole');
    localStorage.removeItem('subscription');
    setView('generator');
    navigate('/'); // Redireciona para tela de login
  };

  // Funções de usuário serão usadas no CRUD/modal futuro

  const saveQrHistory = async (data, config, size, fileType) => {
    try {
      await axios.post(`${API_BASE}/api/qr/save`, {
        data,
        config: JSON.stringify(config),
        size,
        fileType
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchQrHistory();
    } catch (error) {
      console.error('Failed to save QR history');
    }
  };

  const deleteQrHistory = async (id) => {
    try {
      await axios.delete(`${API_BASE}/api/qr/history/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchQrHistory();
    } catch (error) {
      console.error('Failed to delete QR history');
    }
  };

  const uploadLogo = async (file) => {
    if (!file) return;
    try {
      const reader = new FileReader();
      reader.onload = () => setLogoDataUrl(reader.result);
      reader.readAsDataURL(file);
    } catch (e) {
      console.error(e);
    }
  };


  const generateQR = async () => {
    setLoading(true);
    try {
      const config = {
        body,
        eye,
        eyeBall,
        bodyColor,
        bgColor,
        gradientColor1: gradient ? gradientColor1 : null,
        gradientColor2: gradient ? gradientColor2 : null,
        gradientType,
        gradientOnEyes: gradient,
        logoMode: logoModeClean ? 'clean' : 'default',
      };

      // ...a geração do QR Code e o uso de buildContent agora são feitos apenas no QRGenerator.js
    } catch (error) {
      console.error(error);
      alert('Falha ao gerar o QR Code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
  {/* Offline Status Indicator */}
  <OfflineIndicator />

  <Header 
    token={token} 
    userRole={userRole} 
    subscription={subscription}
    setView={setView} 
    setUserRole={setUserRole} 
    setToken={setToken} 
    setUserEmail={setUserEmail} 
    handleLogout={handleLogout} 
  />

  {/* PWA Install Banner for Mobile/Tablet */}
  <PWAInstallBanner />

  <Routes>
        {/* Nova rota para Dashboard unificado */}
        <Route path="/minha-conta" element={
          token ? (
            <Dashboard 
              userRole={userRole}
              subscription={subscription}
              token={token}
              userEmail={userEmail}
              userProfile={{
                name: userName,
                phone: userPhone,
                company: userCompany,
                acceptsPromos: acceptsPromos,
                email: userEmail,
                subscription: subscription,
                createdAt: userCreatedAt
              }}
            />
          ) : (
            <div style={{padding: 32, textAlign: 'center'}}>
              <h2>Acesso Restrito</h2>
              <p>Por favor, faça login para acessar sua conta.</p>
              <button onClick={() => navigate('/connect')} style={{padding: '12px 24px', marginTop: 16}}>
                Fazer Login
              </button>
            </div>
          )
        } />
        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/qrcode-generator" element={<QRGenerator token={token} saveQrHistory={saveQrHistory} userRole={userRole} />} />
        <Route path="/qr-code-whatsapp" element={<SeoIntentPage
          title="QR Code para WhatsApp"
          subtitle="Conecte clientes ao seu WhatsApp em segundos com um QR Code profissional e personalizável."
          bullets={[
            { title: 'Atendimento imediato', text: 'Direcione para conversa direta sem precisar digitar número.' },
            { title: 'Mais conversões', text: 'Ideal para cardápios, vitrines, embalagens e campanhas locais.' },
            { title: 'Personalização completa', text: 'Adicione cores, logo e estilo alinhados à sua marca.' }
          ]}
          contentTitle="Como usar QR Code para WhatsApp no negócio"
          contentBody="Use em materiais impressos, balcão de atendimento, cartões e anúncios. Ao escanear, o cliente abre seu WhatsApp e inicia contato com menos fricção, aumentando taxa de resposta e oportunidades comerciais."
          sections={[
            {
              title: 'Estratégias que aumentam conversão',
              topics: [
                {
                  heading: 'Posicionamento em pontos de decisão',
                  text: 'Coloque o QR Code perto de ofertas, cardápios e vitrines para capturar clientes no momento de maior interesse.'
                },
                {
                  heading: 'Mensagem inicial pronta',
                  text: 'Configure texto pré-definido para facilitar o primeiro contato e padronizar o atendimento comercial.'
                },
                {
                  heading: 'Design alinhado à marca',
                  text: 'Use cores e logo para elevar confiança, melhorar taxa de escaneamento e fortalecer reconhecimento visual.'
                }
              ]
            },
            {
              title: 'Boas práticas técnicas',
              topics: [
                {
                  heading: 'Contraste e legibilidade',
                  text: 'Mantenha contraste alto entre fundo e módulos para evitar falhas de leitura em câmeras antigas.'
                },
                {
                  heading: 'Tamanho mínimo recomendado',
                  text: 'Para impressão, use dimensões suficientes para leitura à distância planejada do público.'
                }
              ]
            }
          ]}
          faq={[
            {
              question: 'Como criar QR Code para WhatsApp com mensagem automática?',
              answer: 'No gerador, selecione o tipo WhatsApp, informe o número e defina a mensagem inicial. Depois personalize e baixe.'
            },
            {
              question: 'Posso usar em cartão, embalagem e fachada?',
              answer: 'Sim. O QR Code pode ser aplicado em qualquer material físico ou digital, desde que tenha tamanho e contraste adequados.'
            },
            {
              question: 'O QR Code de WhatsApp expira?',
              answer: 'Não expira por padrão. Ele continua funcionando enquanto o número e o formato de link permanecerem válidos.'
            }
          ]}
          internalLinks={[
            { to: '/whatsapp-business-com-qr-code', label: 'Guia: WhatsApp Business com QR Code' },
            { to: '/qr-code-wifi', label: 'QR Code para Wi-Fi' },
            { to: '/qr-code-vcard', label: 'QR Code vCard para networking' }
          ]}
        />} />
        <Route path="/qr-code-wifi" element={<SeoIntentPage
          title="QR Code para Wi-Fi"
          subtitle="Facilite o acesso à internet com conexão instantânea para clientes, visitantes e eventos."
          bullets={[
            { title: 'Conexão sem senha digitada', text: 'Basta escanear para entrar na rede com praticidade.' },
            { title: 'Melhor experiência', text: 'Perfeito para restaurantes, clínicas, hotéis e escritórios.' },
            { title: 'Mais segurança operacional', text: 'Reduz compartilhamento verbal e erros de digitação.' }
          ]}
          contentTitle="Vantagens do QR Code de Wi-Fi"
          contentBody="Ao disponibilizar QR Code de Wi-Fi em pontos estratégicos, você acelera o onboarding de visitantes, reduz dúvidas de suporte e melhora a percepção de modernidade do ambiente."
          sections={[
            {
              title: 'Cenários de uso mais eficientes',
              topics: [
                {
                  heading: 'Recepção e balcão',
                  text: 'Exiba o QR Code em local visível para reduzir filas e perguntas repetitivas sobre senha da rede.'
                },
                {
                  heading: 'Mesas e áreas de espera',
                  text: 'Coloque o QR Code em displays para aumentar satisfação e permanência dos clientes no ambiente.'
                },
                {
                  heading: 'Eventos e treinamentos',
                  text: 'Acelere a conexão de grupos grandes sem necessidade de suporte manual individual.'
                }
              ]
            },
            {
              title: 'Padrão de implementação recomendado',
              topics: [
                {
                  heading: 'Separação de rede convidado',
                  text: 'Use rede dedicada para visitantes e mantenha ambientes internos protegidos.'
                },
                {
                  heading: 'Atualização rápida de credenciais',
                  text: 'Ao trocar senha, gere novo QR Code imediatamente para evitar indisponibilidade.'
                }
              ]
            }
          ]}
          faq={[
            {
              question: 'QR Code de Wi-Fi funciona em Android e iPhone?',
              answer: 'Sim. A maioria dos dispositivos atuais reconhece automaticamente o padrão de rede por leitura da câmera.'
            },
            {
              question: 'Preciso digitar senha após escanear?',
              answer: 'Quando configurado corretamente, a conexão é automática sem digitação manual da senha.'
            },
            {
              question: 'Posso trocar a senha e gerar novo código?',
              answer: 'Sim. Sempre que alterar credenciais da rede, gere e substitua o QR Code publicado.'
            }
          ]}
          internalLinks={[
            { to: '/wifi-para-clientes-com-qr-code', label: 'Guia: Wi-Fi para clientes com QR Code' },
            { to: '/qr-code-whatsapp', label: 'QR Code para WhatsApp no atendimento' },
            { to: '/qrcode-generator', label: 'Gerador de QR Code personalizado' }
          ]}
        />} />
        <Route path="/qr-code-vcard" element={<SeoIntentPage
          title="QR Code vCard (Cartão de Visita Digital)"
          subtitle="Compartilhe seus dados profissionais de forma moderna e aumente contatos qualificados."
          bullets={[
            { title: 'Networking inteligente', text: 'Transfira nome, telefone, e-mail e empresa com um scan.' },
            { title: 'Imagem profissional', text: 'Use em cartões, assinaturas e materiais institucionais.' },
            { title: 'Compatível com mobile', text: 'Funciona com os principais leitores e câmeras atuais.' }
          ]}
          contentTitle="Por que usar QR Code vCard"
          contentBody="Substitua trocas manuais de contato por um fluxo rápido e confiável. O vCard via QR Code ajuda equipes comerciais e profissionais liberais a capturar leads e manter dados organizados."
          sections={[
            {
              title: 'Aplicações comerciais com maior retorno',
              topics: [
                {
                  heading: 'Feiras, eventos e reuniões',
                  text: 'Compartilhe contato em segundos e reduza perda de leads por erro de digitação ou esquecimento.'
                },
                {
                  heading: 'Cartões físicos e assinatura de e-mail',
                  text: 'Padronize presença profissional e acelere a inclusão dos seus dados na agenda do cliente.'
                },
                {
                  heading: 'Equipe comercial e atendimento',
                  text: 'Crie códigos individuais para cada colaborador e melhore rastreabilidade de origem dos contatos.'
                }
              ]
            },
            {
              title: 'Qualidade de dados e follow-up',
              topics: [
                {
                  heading: 'Padronização de campos',
                  text: 'Inclua nome, cargo, empresa, telefone e e-mail para garantir registro completo no dispositivo do lead.'
                },
                {
                  heading: 'Atualização periódica',
                  text: 'Revise informações de contato para manter reputação e evitar oportunidades perdidas.'
                }
              ]
            }
          ]}
          faq={[
            {
              question: 'O que é QR Code vCard?',
              answer: 'É um QR Code que armazena dados de contato e permite salvar nome, telefone e e-mail direto na agenda.'
            },
            {
              question: 'Posso usar para equipe inteira?',
              answer: 'Sim. Você pode gerar um código por colaborador e aplicar em cartões, crachás e materiais institucionais.'
            },
            {
              question: 'Funciona offline?',
              answer: 'A leitura e salvamento de contato costumam funcionar sem internet, dependendo do leitor/câmera do dispositivo.'
            }
          ]}
          internalLinks={[
            { to: '/vcard-digital-para-equipes', label: 'Guia: vCard digital para equipes comerciais' },
            { to: '/qr-code-whatsapp', label: 'QR Code para WhatsApp e pré-vendas' },
            { to: '/qrcode-generator', label: 'Criar QR Code personalizado' }
          ]}
        />} />
        <Route path="/whatsapp-business-com-qr-code" element={<SeoIntentPage
          title="WhatsApp Business com QR Code"
          subtitle="Use QR Code para acelerar o primeiro contato, organizar atendimento e aumentar conversão comercial no WhatsApp Business."
          bullets={[
            { title: 'Entrada de leads mais rápida', text: 'Elimine fricção no contato inicial e reduza abandono na jornada.' },
            { title: 'Atendimento padronizado', text: 'Use mensagens iniciais para manter linguagem e processo consistentes.' },
            { title: 'Maior eficiência da equipe', text: 'Centralize canais e reduza tempo com orientações repetitivas.' }
          ]}
          contentTitle="Como aplicar no funil de vendas"
          contentBody="Em campanhas online e materiais físicos, o QR Code para WhatsApp Business cria um atalho direto para conversa. Isso aumenta taxa de resposta e melhora a velocidade de qualificação do lead."
          sections={[
            {
              title: 'Implementação por canal',
              topics: [
                { heading: 'Pontos físicos', text: 'Aplique em vitrine, balcão e embalagem para captar interesse no momento da decisão.' },
                { heading: 'Mídia paga e orgânica', text: 'Inclua em criativos e landing pages para simplificar o caminho até o atendimento.' }
              ]
            }
          ]}
          faq={[
            { question: 'Qual número devo usar no QR Code?', answer: 'Use o número oficial de atendimento comercial para manter histórico e SLA centralizados.' },
            { question: 'Preciso de conta Business?', answer: 'Não é obrigatório, mas o WhatsApp Business oferece recursos melhores para operação profissional.' }
          ]}
          internalLinks={[
            { to: '/qr-code-whatsapp', label: 'Página principal de QR Code para WhatsApp' },
            { to: '/qrcode-generator', label: 'Gerador de QR Code' }
          ]}
        />} />
        <Route path="/wifi-para-clientes-com-qr-code" element={<SeoIntentPage
          title="Wi-Fi para Clientes com QR Code"
          subtitle="Entregue conexão rápida e sem atrito em lojas, restaurantes, clínicas e eventos com QR Code de Wi-Fi."
          bullets={[
            { title: 'Menos suporte operacional', text: 'Reduz solicitações de senha e dúvidas recorrentes no atendimento.' },
            { title: 'Experiência moderna', text: 'Oferece onboarding instantâneo para visitantes e convidados.' },
            { title: 'Escalável para ambientes cheios', text: 'Funciona bem em locais com grande fluxo de pessoas.' }
          ]}
          contentTitle="Padrão recomendado para operação"
          contentBody="A melhor prática é disponibilizar rede de convidados separada da rede interna. Assim, você mantém segurança e facilita troca de credenciais sem impactar operação crítica."
          sections={[
            {
              title: 'Execução sem complicação',
              topics: [
                { heading: 'Exposição estratégica', text: 'Posicione o código em recepção, mesas e áreas de espera para máxima visibilidade.' },
                { heading: 'Governança de acesso', text: 'Atualize senha periodicamente e substitua o QR Code para manter controle.' }
              ]
            }
          ]}
          faq={[
            { question: 'Preciso de app específico para ler?', answer: 'Na maioria dos celulares atuais, a câmera nativa já reconhece QR Code de Wi-Fi.' },
            { question: 'Funciona para redes ocultas?', answer: 'Sim, desde que a configuração de SSID oculto esteja correta no momento da geração.' }
          ]}
          internalLinks={[
            { to: '/qr-code-wifi', label: 'Página principal de QR Code para Wi-Fi' },
            { to: '/qrcode-generator', label: 'Criar QR Code de Wi-Fi agora' }
          ]}
        />} />
        <Route path="/vcard-digital-para-equipes" element={<SeoIntentPage
          title="vCard Digital para Equipes"
          subtitle="Padronize a troca de contatos da sua equipe com QR Code vCard e ganhe velocidade no pós-evento e follow-up."
          bullets={[
            { title: 'Padronização comercial', text: 'Campos consistentes reduzem perda de dados no registro dos leads.' },
            { title: 'Escala para times', text: 'Gere códigos individuais para vendedores, consultores e atendimento.' },
            { title: 'Mais profissionalismo', text: 'Contato salvo na agenda em segundos aumenta percepção de confiança.' }
          ]}
          contentTitle="Quando usar vCard em equipe"
          contentBody="Empresas com atuação em campo, eventos e relacionamento B2B se beneficiam de QR Code vCard por reduzir erros de digitação e acelerar etapas de follow-up comercial."
          sections={[
            {
              title: 'Boas práticas de padronização',
              topics: [
                { heading: 'Modelo único de campos', text: 'Defina padrão com nome completo, cargo, empresa, e-mail e telefone.' },
                { heading: 'Revisão periódica', text: 'Atualize contatos sempre que houver mudança de equipe ou canais de atendimento.' }
              ]
            }
          ]}
          faq={[
            { question: 'Cada pessoa precisa de um QR diferente?', answer: 'Sim, o ideal é um QR Code por colaborador para manter dados corretos de contato.' },
            { question: 'Posso usar em assinatura de e-mail?', answer: 'Pode, e isso aumenta a chance de novos contatos salvarem seus dados rapidamente.' }
          ]}
          internalLinks={[
            { to: '/qr-code-vcard', label: 'Página principal de QR Code vCard' },
            { to: '/qrcode-generator', label: 'Gerar vCard em QR Code' }
          ]}
        />} />
        <Route path="/connect" element={
          <AuthPanel
            email={email} setEmail={setEmail}
            password={password} setPassword={setPassword}
            errorMessage={errorMessage} successMessage={successMessage}
            handleLogin={handleLogin}
            registerName={registerName} setRegisterName={setRegisterName}
            registerEmail={registerEmail} setRegisterEmail={setRegisterEmail}
            registerPassword={registerPassword} setRegisterPassword={setRegisterPassword}
            registerLGPD={registerLGPD} setRegisterLGPD={setRegisterLGPD}
            captchaA={captchaA} captchaB={captchaB}
            captchaInput={captchaInput} setCaptchaInput={setCaptchaInput}
            captchaError={captchaError}
            handleRegisterSubmit={handleRegisterSubmit}
          />
        } />
        <Route
          path="/control-panel"
          element={
            !token ? (
              <Navigate to="/connect" replace />
            ) : (userRole !== 'admin' && userRole !== 'superadmin') ? (
              <Navigate to="/" replace />
            ) : (
              <ControlPanel
                userRole={userRole}
                analytics={analytics}
                users={users}
                fetchUsers={{
                  onCreate: async (form) => {
                    try {
                      await axios.post(`${API_BASE}/api/admin/users`, form, {
                        headers: { Authorization: `Bearer ${token}` }
                      });
                      fetchUsers();
                    } catch (e) {
                      alert('Erro ao criar usuário');
                    }
                  },
                  onEdit: async (user) => {
                    try {
                      await axios.put(`${API_BASE}/api/admin/users/${user.id}`,
                        { email: user.email, password: user.password, role: user.role },
                        { headers: { Authorization: `Bearer ${token}` } }
                      );
                      fetchUsers();
                    } catch (e) {
                      alert('Erro ao editar usuário');
                    }
                  },
                  onDelete: async (id) => {
                    if (!window.confirm('Tem certeza que deseja excluir este usuário?')) return;
                    try {
                      await axios.delete(`${API_BASE}/api/admin/users/${id}`,
                        { headers: { Authorization: `Bearer ${token}` } }
                      );
                      fetchUsers();
                    } catch (e) {
                      alert('Erro ao excluir usuário');
                    }
                  }
                }}
                token={token}
                userProfile={{ name: userName, email: userEmail, role: userRole }}
              />
            )
          }
        />
        <Route
          path="/admin"
          element={
            !token ? (
              <Navigate to="/connect" replace />
            ) : (userRole !== 'admin' && userRole !== 'superadmin') ? (
              <Navigate to="/" replace />
            ) : (
              <AdminUserPage />
            )
          }
        />
        {/* Rotas extras */}
        <Route path="/planos" element={<Plans />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contato" element={<Contact />} />
        <Route path="/privacy" element={<LegalPage
          title="Política de Privacidade"
          updatedAt="03 de março de 2026"
          sections={[
            {
              heading: '1. Coleta de dados',
              paragraphs: [
                'Coletamos dados fornecidos no cadastro, geração de QR Codes, formulário de contato e uso da plataforma.',
                'Também podemos registrar dados técnicos como IP, dispositivo e logs para segurança e prevenção de fraudes.'
              ]
            },
            {
              heading: '2. Uso das informações',
              paragraphs: [
                'Utilizamos os dados para autenticação, suporte, melhoria de serviço e cumprimento de obrigações legais.',
                'Não comercializamos dados pessoais e aplicamos controles de acesso para proteção das informações.'
              ]
            },
            {
              heading: '3. Direitos do titular',
              paragraphs: [
                'Você pode solicitar confirmação de tratamento, correção, anonimização ou exclusão, conforme legislação vigente.',
                'Para solicitações, use o canal oficial em nossa página de contato.'
              ]
            }
          ]}
          relatedLinks={[
            { to: '/terms', label: 'Termos de Uso' },
            { to: '/lgpd', label: 'LGPD' },
            { to: '/cookies', label: 'Política de Cookies' },
            { to: '/contato', label: 'Contato' }
          ]}
        />} />
        <Route path="/terms" element={<LegalPage
          title="Termos de Uso"
          updatedAt="03 de março de 2026"
          sections={[
            {
              heading: '1. Aceite dos termos',
              paragraphs: [
                'Ao usar a QRCodeXpress, você concorda com as regras de uso, políticas de privacidade e legislação aplicável.',
                'O uso indevido da plataforma pode resultar em suspensão de conta e medidas legais cabíveis.'
              ]
            },
            {
              heading: '2. Responsabilidades',
              paragraphs: [
                'O usuário é responsável pelo conteúdo codificado nos QR Codes e pela conformidade desse conteúdo com a lei.',
                'A QRCodeXpress mantém esforços razoáveis de disponibilidade, sem garantia de funcionamento ininterrupto.'
              ]
            },
            {
              heading: '3. Planos e alterações',
              paragraphs: [
                'Recursos e limites variam conforme o plano contratado e podem ser atualizados para melhorias do serviço.',
                'Mudanças relevantes podem ser comunicadas previamente em nossos canais oficiais.'
              ]
            }
          ]}
          relatedLinks={[
            { to: '/privacy', label: 'Política de Privacidade' },
            { to: '/lgpd', label: 'LGPD' },
            { to: '/cookies', label: 'Política de Cookies' },
            { to: '/faq', label: 'FAQ' }
          ]}
        />} />
        <Route path="/lgpd" element={<LegalPage
          title="LGPD"
          updatedAt="03 de março de 2026"
          sections={[
            {
              heading: '1. Bases legais de tratamento',
              paragraphs: [
                'Tratamos dados com fundamento em execução de contrato, cumprimento de obrigação legal e legítimo interesse.',
                'Quando necessário, utilizamos consentimento específico e destacamos essa finalidade ao usuário.'
              ]
            },
            {
              heading: '2. Segurança e retenção',
              paragraphs: [
                'Adotamos medidas técnicas e administrativas para proteção contra acesso não autorizado e perda de dados.',
                'A retenção observa prazos legais e necessidades operacionais relacionadas à prestação do serviço.'
              ]
            },
            {
              heading: '3. Contato do titular',
              paragraphs: [
                'Solicitações sobre tratamento de dados podem ser enviadas pelo canal de contato da plataforma.',
                'Responderemos dentro de prazo razoável, conforme a natureza da solicitação e exigências da LGPD.'
              ]
            }
          ]}
          relatedLinks={[
            { to: '/privacy', label: 'Política de Privacidade' },
            { to: '/terms', label: 'Termos de Uso' },
            { to: '/cookies', label: 'Política de Cookies' },
            { to: '/contato', label: 'Canal de atendimento' }
          ]}
        />} />
        <Route path="/cookies" element={<LegalPage
          title="Política de Cookies"
          updatedAt="03 de março de 2026"
          sections={[
            {
              heading: '1. O que são cookies',
              paragraphs: [
                'Cookies são pequenos arquivos armazenados no navegador para manter preferências e melhorar a experiência.',
                'Eles também ajudam em segurança, desempenho e medição de uso da plataforma.'
              ]
            },
            {
              heading: '2. Tipos utilizados',
              paragraphs: [
                'Usamos cookies essenciais para autenticação e funcionamento básico do sistema.',
                'Podemos usar cookies analíticos para compreender comportamento agregado e otimizar funcionalidades.'
              ]
            },
            {
              heading: '3. Controle pelo usuário',
              paragraphs: [
                'Você pode gerenciar ou bloquear cookies nas configurações do navegador.',
                'A desativação de cookies essenciais pode impactar partes da experiência de uso.'
              ]
            }
          ]}
          relatedLinks={[
            { to: '/privacy', label: 'Política de Privacidade' },
            { to: '/terms', label: 'Termos de Uso' },
            { to: '/lgpd', label: 'LGPD' },
            { to: '/faq', label: 'FAQ' }
          ]}
        />} />
      </Routes>
  
  {/* Bottom Navigation Bar - PWA Mobile/Tablet */}
  <BottomNav token={token} />
  
  <Footer />
    </div>
  );
}

function App() {
  // Initialize PWA utilities on mount
  useEffect(() => {
    initializePWA();
    
    // Initialize install prompt
    PWAInstall.init(() => {
      console.log('[App] PWA install prompt available');
    });
    
    // Log device info for debugging
    console.log('[App] PWA initialized:', {
      isPWA: DeviceDetection.isPWA(),
      deviceType: DeviceDetection.getDeviceType(),
      orientation: DeviceDetection.getOrientation(),
      isOnline: DeviceDetection.isOnline()
    });
  }, []);

  return (
    <Router>
      <RouterApp />
    </Router>
  );
}
export default App;